import { createSelector } from 'reselect'
import { detectLanguage } from 'helpers/functions'

const getStorefrontVisitorData = state => state.storefront.visitor

const storefront_visitor_header_selector = createSelector(
	[ getStorefrontVisitorData ],
	visitorState => {

		const ownerUserData = {}
		ownerUserData.profilePicture = visitorState.data.owner_profile_picture
		ownerUserData.userName = visitorState.data.owner_name
		ownerUserData.schoolName = visitorState.data.owner_school
		ownerUserData.userGrades = visitorState.data.grades
		ownerUserData.userSubjects = visitorState.data.subjects
		ownerUserData.followersCount = visitorState.data.owner_follow_data.data.ownerFollowersCount
		ownerUserData.entityUID = visitorState.data.owner_follow_data.data.entityUID
		ownerUserData.ownerId = visitorState.data.ownerId

		if (visitorState.data.owner_account_date) {
			const locale = detectLanguage()
			const accountDate = new Date(parseInt(visitorState.data.owner_account_date)*1000)
			const accountMonth = accountDate.toLocaleString(locale, { month: 'long' })
			const accountYear = accountDate.getFullYear()
			ownerUserData.accountDate = accountMonth + ' ' + accountYear
		} else {
			ownerUserData.accountDate = ''
		}

		const lessonsCount = visitorState.lessons.count ? visitorState.lessons.count : ' '

		return {
			ownerUserData,
			bio: visitorState.data.bio,
			downloadsCount: visitorState.data.downloads,
			count: lessonsCount,
			isFollowing: visitorState.data.owner_follow_data.data.isFollowing,
		}
	}
)

export default storefront_visitor_header_selector
